import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerYoutubeComparePosts.graphql';
import { Query, QueryinfluencerYoutubeComparePostsArgs } from '../../__generated__/globalTypes';

export const useInfluencerYoutubeComparePostsQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerYoutubeComparePostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerYoutubeComparePostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerYoutubeComparePostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerYoutubeComparePostsArgs>
): QueryResult<Query, QueryinfluencerYoutubeComparePostsArgs> & {
  getInfluencerYoutubeComparePosts: LazyQueryExecFunction<Query, QueryinfluencerYoutubeComparePostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerYoutubeComparePosts, result] = useLazyQuery<Query, QueryinfluencerYoutubeComparePostsArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInfluencerYoutubeComparePosts, ...result };
};

export const useInfluencerYoutubeComparePostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerYoutubeComparePosts = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerYoutubeComparePostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerYoutubeComparePostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerYoutubeComparePosts };
};
// Suspense Query Hooks
export const useInfluencerYoutubeComparePostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerYoutubeComparePostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerYoutubeComparePostsArgs>(QUERY, {
    ...options
  });

  return result;
};
